import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./landing.css";
import { Navbar } from "./components/Navbar";
import { HeroSection } from "./components/HeroSection";
import { SolutionsExplorer } from "./components/SolutionsExplorer";
import { GoogleReviewsSection } from "./components/GoogleReviewsSection";
import { ReferAndEarnSection } from "./components/ReferAndEarnSection";
import { AboutSection } from "./components/AboutSection";
import { Footer } from "./components/Footer";
import { InquiryModal } from "./components/InquiryModal";
import { ProductDetailsModal } from "./components/ProductDetailsModal";
import { WhatsAppWidget } from "./components/WhatsAppWidget";

const HEADER_OFFSET = 80;

const hasValidSession = () => {
  try {
    const token = localStorage.getItem("Token");
    if (!token) return false;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload?.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
  window.scrollTo({ top, behavior: "smooth" });
};

const LandingPage = () => {
  const navigate = useNavigate();
  const [isLoggedIn] = useState(hasValidSession);
  const [inquiryOpen, setInquiryOpen] = useState(false);
  const [inquirySolution, setInquirySolution] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    document.title = "Fi Pay Bills | Pay-In, Payout & Banking Solutions for Indian Businesses";
    if (window.location.hash) {
      setTimeout(() => scrollToSection(window.location.hash.slice(1)), 100);
    }
  }, []);

  const openInquiry = useCallback((solution) => {
    setInquirySolution(solution || "");
    setInquiryOpen(true);
  }, []);

  const closeInquiry = useCallback(() => setInquiryOpen(false), []);
  const closeProduct = useCallback(() => setSelectedProduct(null), []);

  const handleNavigate = useCallback(
    (view, hash) => {
      if (view === "signin") return navigate("/signin");
      if (view === "signup") return navigate("/signup");
      if (view === "dashboard") return navigate("/dashboard");
      if (hash) return scrollToSection(hash);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    [navigate]
  );

  return (
    <div className="fi-landing">
      <div className="min-h-screen bg-white text-slate-900 flex flex-col selection:bg-blue-600 selection:text-white">
        <Navbar onNavigate={handleNavigate} onOpenInquiry={openInquiry} isLoggedIn={isLoggedIn} />

        <main className="flex-1">
          <HeroSection onOpenInquiry={openInquiry} onExploreClick={() => scrollToSection("solutions-section")} />
          <SolutionsExplorer onSelectProduct={setSelectedProduct} onOpenInquiry={openInquiry} />
          <div id="reviews-section">
            <GoogleReviewsSection onOpenInquiry={openInquiry} />
          </div>
          <ReferAndEarnSection onOpenInquiry={openInquiry} onNavigateToSignIn={() => handleNavigate("signin")} />
          <AboutSection onOpenInquiry={openInquiry} />
        </main>

        <Footer onNavigate={handleNavigate} onOpenInquiry={openInquiry} />

        <ProductDetailsModal product={selectedProduct} onClose={closeProduct} onOpenInquiry={openInquiry} />
        <InquiryModal isOpen={inquiryOpen} onClose={closeInquiry} preselectedSolution={inquirySolution} />
        <WhatsAppWidget />
      </div>
    </div>
  );
};

export default LandingPage;
